import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

/**
 * Firebase email-action entrypoint.
 * In Firebase Console → Authentication → Templates → customize action URL to:
 *   https://<your-frontend-domain>/auth/action
 */
const AuthActionHandler = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const mode = searchParams.get('mode')
    const oobCode = searchParams.get('oobCode')
    const continueUrl = searchParams.get('continueUrl')
    const lang = searchParams.get('lang')
    const apiKey = searchParams.get('apiKey')

    const qs = new URLSearchParams()
    if (oobCode) qs.set('oobCode', oobCode)
    if (mode) qs.set('mode', mode)
    if (continueUrl) qs.set('continueUrl', continueUrl)
    if (lang) qs.set('lang', lang)
    if (apiKey) qs.set('apiKey', apiKey)
    const suffix = qs.toString() ? `?${qs.toString()}` : ''

    if ((mode === 'resetPassword' || !mode) && oobCode) {
      navigate(`/reset-password-action${suffix}`, { replace: true })
      return
    }

    navigate('/auth', { replace: true })
  }, [navigate, searchParams])

  return null
}

export default AuthActionHandler
